import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  GroupSelect,
  omitNullFields,
  TextField,
} from "../../../components/Form";
import { useStudioForm } from "../../../components/Form/hooks";
import { useCreateLog } from "../../../domain/crud";
import { makeLogLocation, useStudioNavigate } from "../../../paths";
import { createLogSchema } from "./validation";

export default function LogForm() {
  const navigate = useStudioNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const createLog = useCreateLog();

  const { control, handleSubmit } = useStudioForm({
    schema: createLogSchema,
    defaultValues: {
      name: null,
      note: null,
      groupId: null,
    },
    onSubmit(values) {
      createLog.mutate(omitNullFields(values), {
        onSuccess(response) {
          navigate(makeLogLocation(response.data.id));
        },
        onError() {
          enqueueSnackbar("Unable to create log", { variant: "error" });
        },
      });
    },
  });

  return (
    <Card>
      <CardContent>
        <Grid component="form" container onSubmit={handleSubmit} spacing={2}>
          <Grid item xs={3}>
            <TextField control={control} name="name" />
          </Grid>
          <Grid item xs={3}>
            <GroupSelect control={control} name="groupId" label="Group" />
          </Grid>
          <Grid item xs={6}>
            <TextField control={control} name="note" />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              loading={createLog.isLoading}
              type="submit"
              variant="contained"
            >
              Create
            </LoadingButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
